import React from "react";
import {
  AlertOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

export interface NoticeTickerItem {
  id: number;
  title: string;
  level: number;
}

interface NoticeTickerProps {
  notices: NoticeTickerItem[];
  onOpen: (notice: NoticeTickerItem) => void;
  width?: number;
}

const getNoticeLevelIcon = (level: number) => {
  switch (level) {
    case 1:
      return <AlertOutlined style={{ color: "#ff4d4f", marginRight: 4 }} />;
    case 2:
      return <ExclamationCircleOutlined style={{ color: "#fa8c16", marginRight: 4 }} />;
    default:
      return <InfoCircleOutlined style={{ color: "#1890ff", marginRight: 4 }} />;
  }
};

const NoticeTicker: React.FC<NoticeTickerProps> = ({ notices, onOpen, width = 250 }) => {
  if (notices.length === 0) return null;

  const loopItems = notices.length > 1 ? [...notices, notices[0]] : notices;
  const duration = Math.max(loopItems.length * 5, 10);

  return (
    <div
      style={{
        width,
        height: 40,
        overflow: "hidden",
        marginRight: 16,
        position: "relative",
        borderRadius: 8,
        background: "rgba(255, 245, 230, 0.5)",
        border: "1px solid rgba(255, 204, 0, 0.3)",
        display: "flex",
        alignItems: "center",
        paddingLeft: 8,
      }}
    >
      <style>{`
        @keyframes noticeTickerY {
          0%, 24% { transform: translateY(0); }
          30%, 54% { transform: translateY(-40px); }
          60%, 84% { transform: translateY(-80px); }
          90%, 100% { transform: translateY(-120px); }
        }
      `}</style>
      <div style={{ flex: 1, overflow: "hidden", height: "100%", position: "relative" }}>
        <div
          style={{
            animation: notices.length > 1 ? `noticeTickerY ${duration}s ease-in-out infinite` : undefined,
            position: "absolute",
            width: "calc(100% - 8px)",
          }}
        >
          {loopItems.map((notice, index) => (
            <div
              key={`${notice.id}-${index}`}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: 40,
                lineHeight: "40px",
                cursor: "pointer",
                color: "#333",
                fontSize: 14,
                padding: "0 4px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => onOpen(notice)}
            >
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                {getNoticeLevelIcon(notice.level)}
              </span>
              <span style={{ paddingLeft: 6, marginLeft: 2 }}>{notice.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoticeTicker;
